import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./TreatmentSection.css";
import img1 from "../images/post_natal.webp"
import img2 from "../images/main_reju.webp"
import img3 from "../images/main_hair.webp"
import img4 from "../images/main_life.webp"
import img5 from "../images/main_kalpa.webp"
import { BiSolidLeaf } from "react-icons/bi";
import { Link } from "react-router-dom";

export default function TreatmentSection() {
  return (
    <section className=" container-fluid services-wrapper">
      <div className="container">

        {/* ===== HEADER ===== */}
        <div className="row ">
          <div className="col-lg-12">
            <p className="services-label"><b>OUR SERVICES</b></p>
            <h2 className="services-title">
              A Landing Place to Heal Traditionally
            </h2>
             <p className="justify-text para-font" >
              At Ayur Moksha, we offer a wide spectrum of authentic Ayurvedic therapies designed to restore balance, rejuvenate body and mind, and promote lasting wellness. Our approach goes beyond treatment—it is a holistic journey that nurtures vitality, prevents illness, and strengthens the connection between body, mind, and lifestyle.
We bring classical Ayurvedic practices to life as practical solutions for preventive care, long-term wellness, and postnatal recovery. Our clinic provides a calm, personalized environment where healing is respected, holistic, and never rushed, allowing every guest to reconnect with their natural balance and well-being.

            </p> <br/><br/>
          </div>
          
        </div>

        {/* ===== SERVICE 1 ===== */}
        <div className="row service-block">
          <div className="col-lg-6 position-relative">
            <div className="service-img">
              <img src={img1} alt="Ayurvedic Massage" />
              <div className="service-icon left-icon"><BiSolidLeaf/></div>
            </div>
          </div>

          <div className="col-lg-6 position-relative">
            <div className="service-card">
              <h4 className="head-font">Postnatal Care</h4>
              <p className="para-font justify-text"  >
                 Ayur Moksha goes beyond treatments, offering a serene and nurturing space to relax, unwind, and restore yourself after the demands of your prenatal journey.
Our Postnatal Ayurvedic Care Package is thoughtfully designed to restore balance, rebuild strength, support healthy lactation, and promote complete rejuvenation in a natural and safe way.
As part of the program, medicines are carefully prepared in-house using handpicked herbs. In addition, we use trusted, externally sourced Ayurvedic medicines from reputed manufacturers, ensuring gentle, effective, and reliable postnatal care with the highest standards of safety and quality.

            </p> <Link className="btn btn-outline-success service-btn"  to="/postNatal">
                Learn More →
              </Link>
            </div>
          </div>
        </div>

        {/* ===== SERVICE 2 ===== */}
        <div className="row align-items-center service-block reverse">
           <div className="col-lg-6 position-relative order-lg-1">
            <div className="service-card">
              <h4 className="head-font">Rejuvenation Therapy</h4>
              <p className="para-font justify-text" >
                Along the banks of a serene river, our clinic becomes a sanctuary for renewal. Here, Rejuvenation Plans are experienced slowly, 
                allowing the body and mind to settle into deep rest. Care is enriched by carefully chosen herbs prepared in-house, alongside trusted 
                Ayurvedic medicines sourced from established manufacturers, bringing together purity, safety, and tradition. In this peaceful setting, 
                healing feels gentle, complete, and enduring
              </p>

            

              <Link className="btn btn-outline-success service-btn"  to="/rejuvenation">
                Learn More →
              </Link>
            </div>
          </div>

          <div className="col-lg-6 position-relative order-lg-4 ">
            <div className="service-img">
              <img src={img2} alt="Herbal Steam Therapy" />
              <div className="service-icon right-icon"><BiSolidLeaf/></div>
            </div>
          </div>

         
        </div>

           {/* ===== SERVICE 3 ===== */}
        <div className="row align-items-center service-block">
          <div className="col-lg-6 position-relative">
            <div className="service-img">
              <img src={img3} alt="Ayurvedic Massage" />
            <div className="service-icon left-icon"><BiSolidLeaf/></div>
            </div>
          </div>

          <div className="col-lg-6 position-relative">
            <div className="service-card">
              <h4 className="head-font">Hair Treatment</h4>
              <p className="para-font justify-text">
              At Ayur Moksha, our hair treatments follow traditional Ayurvedic methods focused on improving scalp health and strengthening hair
               from within. Our calm, healing clinic environment is designed to enhance the effectiveness of each therapy, allowing the body and
               
                mind to respond naturally.
                 Our therapies are supported by select Ayurvedic medicines, thoughtfully handpicked by our physicians from our medicinal garden
                  and complemented with formulations sourced from trusted partners known for their authenticity, purity, and effectiveness.

            </p>
            <Link className="btn btn-outline-success service-btn"  to="/hair">
                Learn More →
              </Link>
            </div>
          </div>
        </div>

         {/* ===== SERVICE 4 ===== */}
        <div className="row align-items-center service-block reverse">
           <div className="col-lg-6 position-relative order-lg-1">
            <div className="service-card">
              <h4 className="head-font">Life Style Guidance & Yoga </h4>
              <p className="para-font justify-text"  >
                Ayur Moksha is an ideal platform to help you rediscover and embrace the lifestyle you deserve for a healthier, more balanced tomorrow. Through personalized lifestyle guidance rooted in traditional  Ayurvedic principles, we help you establish daily routines that support physical vitality, mental clarity, and emotional stability. This guidance gently removes stress patterns and mental blocks, allowing a natural sense of balance and well-being to emerge.
Complementing this journey, our serene river-view yoga sessions offer a deeply refreshing start to the day. Practiced in harmony with nature, these sessions enhance flexibility, improve breath awareness, calm the mind, and energize the body—setting a positive, focused tone that carries through the day.

              </p>
              <Link className="btn btn-outline-success service-btn"  to="/lifeCycle">
                Learn More →
              </Link>
            </div>
          </div>

          <div className="col-lg-6 position-relative order-lg-4 ">
            <div className="service-img">
              <img src={img4} alt="Herbal Steam Therapy"  height={500}/>
              <div className="service-icon right-icon"><BiSolidLeaf/></div>
            </div>
          </div>

         
        </div>

           {/* ===== SERVICE 5 ===== */}
        <div className="row align-items-center service-block" style={{marginBottom:'-2%'}}>
          <div className="col-lg-6 position-relative">
            <div className="service-img">
              <img src={img5} alt="Ayurvedic Massage" />
             <div className="service-icon right-icon"><BiSolidLeaf/></div>
            </div>
          </div>

          <div className="col-lg-6 position-relative">
            <div className="service-card">
              <h4 className="head-font">Soundarya Kalpa</h4>
              <p className="para-font justify-text">
                Our healing hands help bring out your natural beauty, allowing your unique personality to shine with confidence. Through a detailed and thoughtful assessment, we identify the most suitable treatments to be offered under the Soundarya Kalpa program.
          Each therapy is supported by carefully handpicked medicines, sourced from our medicinal garden and trusted Ayurvedic vendors, ensuring high purity, effectiveness, and enhanced recovery through traditional healing methods.
            </p>
              <Link className="btn btn-outline-success service-btn"  to="/soundarya">
                Learn More →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
